import { Component, ElementRef, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import * as _ from 'lodash-es';
declare var $: any;
import { GridEventService } from '../../../grid/services/grid-event.service';
import { DashboardComponent } from '../../models/DashboardComponent';
import { HorizontalBusinessGroupNode } from '../../models/HorizontalBusinessGroupNode';
import { ExDashboardEventService } from '../../services/event.service';

@Component({
    selector: 'ex-horizontal-business-group',
    templateUrl: './ex-horizontal-business-group.component.html',
    styleUrls: ['./ex-horizontal-business-group.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class HorizontalBusinessGroupComponent implements OnInit {
  @Input()
  options!: DashboardComponent;

  collapse: boolean = false;
  container: any;

  selectedMes: HorizontalBusinessGroupNode[] = [];
  initialHighlighted = true;
  meFilterName = 'me';
  cntrlKeyDown: boolean = false;
  element: any;

  constructor(private eventService: ExDashboardEventService,
    element: ElementRef) {
    this.element = element.nativeElement;
    this.container = $(this.element).find('.nodes');

  }

  ngOnInit(): void {
    this.options.extraOptions.componentSettings.invertColors && this.invertColors();
    this.options.extraOptions.componentSettings.minWidthPercentage = "5%";
    this.options.extraOptions.componentSettings.areaWidth = 2000;

    this.container = $(this.element).find('.nodes');

    this.calculateNodeWidths(this.options.extraOptions.componentSettings.areaWidth, this.options.data.nodes, parseFloat(this.options.extraOptions.componentSettings.minWidthPercentage), true)

    this.container.on("mousewheel", (e: any) => this.scrollHorizontally(e));//chrome, IE
    this.container.on("DOMMouseScroll", (e: any) => this.scrollHorizontally(e));//firefox
  }

  invertColors() {
    this.options.data.nodes.forEach((node: HorizontalBusinessGroupNode) => {
      node.color === "#4eb523" ? node.color = "#e86153" : node.color = "#4eb523";
    });
  }

  nodeClicked(event: MouseEvent, node: HorizontalBusinessGroupNode) {
    if (!event.ctrlKey) {
      this.selectedMes = [];
      for (var i = 0; i < this.options.data.nodes.length; i++) {
        this.options.data.nodes[i].selected = false;
      }
    }

    this.selectOrUnselectMe(node);

    this.initialHighlighted = this.selectedMes.length === 0;

    this.eventService.broadcast('dashboard:meSelected', { node, ctrlKey: event.ctrlKey });
  }

  selectOrUnselectMe(node: HorizontalBusinessGroupNode) {
    if (!this.selectedMes.includes(node)) {
      this.selectedMes.push(node);
      node.selected = true;
    } else {
      node.selected = false;
      this.selectedMes.splice(this.selectedMes.indexOf(node), 1);
    }
  }

  setFilter(e: any, filter: { LABEL: string; VALUE: string }[]) {

    if (!filter) {
      return;
    }

    var deletedMes = _.difference(_.map(this.selectedMes, 'name'), _.map(filter, 'VALUE'));
    var newMes = _.difference(_.map(filter, 'VALUE'), _.map(this.selectedMes, 'name'));

    if (deletedMes.length > 0) {
      _.remove(this.selectedMes, function(item) {
        return deletedMes.includes(item.name);
      });
    }

    if (newMes.length > 0) {
      this.selectedMes = _.concat(this.selectedMes, _.filter(this.options.data, function(item) {
        return newMes.includes(item.name);
      }))
    }

    for (var i = 0; i < this.options.data.length; i++) {
      var me = this.options.data[i];

      if (deletedMes.includes(me.name)) {
        me.selected = false;
      } else if (newMes.includes(me.name)) {
        me.selected = true;
        if (this.moveToSelectedEntity)
          this.moveToSelectedEntity(me)
      }

    }

    this.initialHighlighted = this.selectedMes.length === 0;
  }

  moveToSelectedEntity(id: string) {
    var selectedNode = $(this.element).find("#node-" + id);
    $(this.element).find(".nodes").animate({
      scrollLeft: $(this.element).find(".nodes").scrollLeft()!
        + selectedNode.position().left
        - selectedNode.width()! / 2
        - $(this.element).find(".nodes").width()! / 4
    }, 200)
    console.log(selectedNode)
  }

  calculateNodeWidths(areaWidth: number, nodes: HorizontalBusinessGroupNode[], minWidth: number, flag: boolean) {
    var totalSum = _.sumBy(nodes, 'value')
    var minWidthPercentage = (areaWidth * minWidth) / 100
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].width = (nodes[i].value * areaWidth) / totalSum;
      if (nodes[i].width < 10) {
        nodes[i].extraWidth = 10 - nodes[i].width;
        nodes[i].width = 10;
      }
      if (flag) {
        if (nodes[i].width < minWidthPercentage) {
          nodes[i].width = minWidthPercentage
        }
      }
    }

    var totalExtraWidth = _.sumBy(nodes, 'extraWidth');
    var largerNodes = nodes.filter(function(item) {
      return item.width > 10;
    })
    var extraWidthToDistribute = totalExtraWidth / largerNodes.length;
    nodes.map(function(item) {
      if (!flag) {
        if (item.width > 10) {
          item.width = item.width - extraWidthToDistribute
        }
      }
      return item;
    })
    console.log(totalExtraWidth)
  }

  toggleTreeChart(event: any) {
    this.collapse = !this.collapse
    var icon = $(this.element).find('.icon');
    if (this.collapse) {
      icon.addClass('icon-compressed');
      // icon.find('i').addClass('rotate');
      var containerWidth = event.currentTarget.parentElement.clientWidth
    }
    else {
      var containerWidth = this.options.extraOptions.componentSettings.areaWidth
      icon.removeClass('icon-compressed');
      icon.children().addClass('streching');
      setTimeout(function() {
        icon.children().removeClass('streching');
        // icon.find('i').removeClass('rotate');
      }, 500)

    }

    this.calculateNodeWidths(containerWidth, this.options.data.nodes, parseFloat(this.options.extraOptions.componentSettings.minWidthPercentage), !this.collapse)

  }

  scrollHorizontally(e: any) {

    e = window.event || e.originalEvent;
    var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
    console.log("delta", delta)
    this.container[0].scrollLeft -= delta * 100;
    e.preventDefault();
  }
}
